<template>
  <v-container>
    <v-layout>
      <v-flex>
        <div class="headline primary--text">
          {{ $t('Status Management') }}
        </div>
      </v-flex>
      <v-flex class="default-input">
        <v-text-field
          id="search"
          v-model="search"
          name="search"
          single-line
          :placeholder="$t('Search')"
          outline
          clearable
          prepend-inner-icon="search"
          hide-details
          @blur="onSearch"
          @keydown.enter="onSearch"
          @input="onSearch"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row justify-end class="mb-0">
      <v-btn class="mx-0" color="primary" @click="showModelCreateStatus = true">สร้างสถานะ</v-btn>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1 mt-3"
      :pagination.sync="pagination"
      :loading="loading"
      :total-items="total"
    >
      <template #items="props">
        <tr>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-right">
            <template v-if="[...$store.state.bbqPage].includes(selectedBot.pageid)">
              <v-btn
                icon
                ripple
                flat
                :color="handleGetStatusWithColorByName(props.item.name)"
                @click="handleSetStatusColor(props.item)"
              >
                <v-icon>format_color_fill</v-icon>
              </v-btn>
            </template>
            <v-btn fab small depressed @click="onDelete(props.item.id)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-if="selectedStatus" v-model="showColorPalette" persistent width="350px">
      <v-card class="pa-3">
        <div class="caption">* ภาพตัวอย่าง</div>
        <div class="text-xs-center py-3">
          <v-chip :color="selectedColor" text-color="white">{{ selectedStatus.name }}</v-chip>
        </div>
        <v-divider />
        <swatches
          v-model="selectedColor"
          inline
          show-fallback
          fallback-input-type="color"
        ></swatches>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="handleCancel">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="handleSaveStatusColor">{{ $t('Save') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showModelCreateStatus"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <div class="text-xs-right">
          <v-btn small flat fab @click="closeModelCreateStatus()">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <h1 class="text-center">สร้างสถานะ</h1>
        <div style="padding: 20px">
          <div>ชื่อสถานะ</div>
          <div class="default-input">
            <v-text-field
              id="search"
              v-model="createStatusName"
              name="search"
              single-line
              placeholder="ชื่อสถานะ"
              outline
              clearable
              hide-details
              @keydown.enter="handleCreateStatus(createStatusName)"
            ></v-text-field>
          </div>
        </div>
        <v-layout row justify-center>
          <v-btn outline :loading="loading" @click="closeModelCreateStatus()">ยกเลิก</v-btn>
          <v-btn color="primary" :loading="loading" @click="handleCreateStatus(createStatusName)"
            >สร้าง</v-btn
          >
        </v-layout>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'
import usersApi from '@/api/users'

export default {
  components: {
    Swatches
  },
  data() {
    return {
      search: '',
      headers: [
        {
          value: 'name',
          text: 'Name',
          align: 'center'
        },
        {
          text: '',
          sortable: false
        }
      ],
      items: [],
      pagination: { sortBy: 'name', descending: true, rowsPerPage: 25 },
      loading: true,
      updateSearchTimeout: null,
      total: 0,
      allStatusColor: null,
      showColorPalette: false,
      selectedStatus: null,
      selectedColor: '',
      dialogType: null,
      showModelCreateStatus: false,
      createStatusName: ''
    }
  },
  mounted() {
    if ([...this.$store.state.bbqPage].includes(this.selectedBot.pageid)) {
      this.handleFetchDataStatusColor()
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    closeModelCreateStatus() {
      this.showModelCreateStatus = false
      this.createStatusName = ''
    },
    async handleCreateStatus(statusName) {
      try {
        const body = {
          page_id: this.selectedBot.pageid,
          user_status_data: [statusName]
        }
        this.loading = true
        await usersApi.postCreateStatus(body)
        this.closeModelCreateStatus()
        const { result, total } = await this.getUserStatusList()
        this.items = result
        this.total = total
      } catch (error) {
        this.$swal.fire({
          text: 'สร้าง status ไม่สำเร็จ',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    onSearch() {
      const vm = this
      if (vm.updateSearchTimeout) {
        clearTimeout(vm.updateSearchTimeout)
      }
      if (this.loading) return false
      vm.updateSearchTimeout = setTimeout(async () => {
        vm.loading = true
        try {
          const { result, total } = await vm.getUserStatusList()
          vm.items = result
          vm.total = total
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
        vm.updateSearchTimeout = null
      }, 3000)
    },
    async getUserStatusList() {
      const { page, rowsPerPage } = this.pagination
      let offset = (page - 1) * rowsPerPage,
        limit = page * rowsPerPage
      if (rowsPerPage == -1) {
        limit = 999999
        offset = 0
      }
      var response = await api.getUserStatusList({
        offset,
        limit,
        filter_name: this.search || undefined
      })
      if (response && response.result) {
        return { result: response.result, total: response.total_count || 0 }
      } else {
        return { result: [], total: 0 }
      }
    },
    async onDelete(id) {
      let result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        let index = this.items.findIndex((el) => el.id == id)
        if (index != -1) {
          let response = await api.deleteUserStatusList({
            body: {
              id: id,
              status: this.items[index].name
            }
          })

          if ([...this.$store.state.bbqPage].includes(this.selectedBot.pageid)) {
            let responseColor = await this.deleteStatusColor(this.items[index].name)

            if (!responseColor) {
              this.$swal.fire({
                type: 'error',
                title: this.$t('Error')
              })
            }
          }

          if (response.success) {
            this.$swal.fire({
              type: 'success',
              title: this.$t('Success')
            })
            this.items.splice(index, 1)
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$t('Error')
            })
          }
        }
      }
    },
    async handleFetchDataStatusColor() {
      const vm = this
      try {
        const pageId = vm.selectedBot.pageid
        vm.$store.dispatch('loading')
        const response = await api.getStatusColor(pageId)
        vm.$store.dispatch('loading')
        if (response && response.data) {
          vm.allStatusColor = response.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleSaveStatusColor() {
      const vm = this
      let response = null
      if (vm.dialogType === 'add') {
        response = await vm.createStatusColor()
      } else if (vm.dialogType === 'edit') {
        let result = await vm.$swal.fire({
          title: 'Do you want to this save color ?',
          type: 'warning',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          showCancelButton: true
        })
        if (result.value) {
          response = await vm.updateStatusColor()
        }
      }

      if (response) {
        vm.handleFetchDataStatusColor()
        vm.handleReset()
        vm.handleCloseColorPaletteDialog()
      }
    },
    async createStatusColor() {
      const vm = this
      try {
        let data = {
          page_id: vm.selectedBot.pageid,
          status: vm.selectedStatus.name,
          color: vm.selectedColor
        }
        const response = await api.addStatusColor(data)
        if (response) {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.error(error)
      }
    },
    async updateStatusColor() {
      const vm = this

      try {
        const statusColor = vm.allStatusColor.find((el) => {
          return el.status === vm.selectedStatus.name
        })

        if (statusColor.id) {
          let data = {
            id: statusColor.id,
            status: vm.selectedStatus.name,
            color: vm.selectedColor
          }
          const response = await api.updateStatusColor(data)
          if (response) {
            return true
          } else {
            return false
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deleteStatusColor(status) {
      const vm = this

      try {
        const statusColor = vm.allStatusColor.find((el) => {
          return el.status === status
        })

        if (statusColor.id) {
          let data = {
            id: statusColor.id
          }
          const response = await api.deleteStatusColor(data)
          if (response) {
            return true
          } else {
            return false
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleSetStatusColor(item) {
      const color = this.handleGetStatusWithColorByName(item.name)
      if (color) {
        this.dialogType = 'edit'
        this.selectedColor = color
      } else {
        this.dialogType = 'add'
      }

      this.selectedStatus = item
      this.showColorPalette = true
    },
    handleCancel() {
      this.handleReset()
      this.handleCloseColorPaletteDialog()
    },

    handleCloseColorPaletteDialog() {
      this.showColorPalette = false
    },
    handleReset() {
      this.selectedColor = ''
      this.selectedStatus = null
      this.dialogType = null
    },
    handleGetStatusWithColorByName(status) {
      const allStatusWithColor = this.allStatusColor

      const filterStatus = allStatusWithColor.find((el) => {
        return el.status === status
      })

      return filterStatus ? filterStatus.color : ''
    }
  },
  watch: {
    pagination: {
      async handler() {
        this.loading = true
        try {
          const { result, total } = await this.getUserStatusList()
          this.items = result
          this.total = total
        } catch (error) {
          console.error(error)
        }
        this.loading = false
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/tag/StatusManagement.vue